import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
  getContacts as getContactsApi,
  getDeals as getDealsApi,
  getLeads as getLeadsApi,
  addNewContact as addNewContactApi,
  updateContact as updateContactApi,
  deleteContact as deleteContactApi,
  addNewLead as addNewLeadApi,
  updateLead as updateLeadApi,
  deleteLead as deleteLeadApi
} from "../../helpers/fakebackend_helper";

// Import real API services
import { companiesService } from "../../services/companiesService";
import { individualsService } from "../../services/individualsService";

export const getContacts = createAsyncThunk("crm/getContacts" , async () => {
  try{
    const response = getContactsApi()
    return response;
  }catch (error) {
    return error;
  }
})

export const getCompanies = createAsyncThunk("crm/getCompanies" , async () => {
  try{
      const response = await companiesService.getAll();
      return response;
  }catch (error) {
    return error;
  }
})

export const addNewCompanies = createAsyncThunk("crm/addNewCompanies" , async (company:any) => {
  try{
    const response = await companiesService.create(company);
    toast.success("Empresa adicionada com sucesso", { autoClose: 3000 });
    return response;
  }catch (error: any) {
    toast.error(error.response?.data?.message || "Falha ao adicionar empresa", { autoClose: 3000 });
    throw error;
  }
})

export const updateCompanies = createAsyncThunk("crm/updateCompanies" , async (company:any) => {
  try{
    await companiesService.update(company);
    toast.success("Empresa atualizada com sucesso", { autoClose: 3000 });
    return company;
  }catch (error: any) {
    toast.error(error.response?.data?.message || "Falha ao atualizar empresa", { autoClose: 3000 });
    throw error;
  }
})

export const deleteCompanies = createAsyncThunk("crm/deleteCompanies" , async (companyId:string) => {
  try{
    await companiesService.delete(companyId);
    toast.success("Empresa excluída com sucesso", { autoClose: 3000 });
    return companyId;
  }catch (error: any) {
    toast.error(error.response?.data?.message || "Falha ao excluir empresa", { autoClose: 3000 });
    throw error;
  }
})

// ===== INDIVIDUALS THUNKS =====

export const getIndividuals = createAsyncThunk("crm/getIndividuals" , async () => {
  try{
      const response = await individualsService.getAll();
      return response;
  }catch (error) {
    return error;
  }
})

export const addNewIndividual = createAsyncThunk("crm/addNewIndividual" , async (individual:any) => {
  try{
    const response = await individualsService.create(individual);
    toast.success("Pessoa física adicionada com sucesso", { autoClose: 3000 });
    return response;
  }catch (error: any) {
    toast.error(error.response?.data?.message || "Falha ao adicionar pessoa física", { autoClose: 3000 });
    throw error;
  }
})

export const updateIndividual = createAsyncThunk("crm/updateIndividual" , async (individual:any) => {
  try{
    await individualsService.update(individual);
    toast.success("Pessoa física atualizada com sucesso", { autoClose: 3000 });
    return individual;
  }catch (error: any) {
    toast.error(error.response?.data?.message || "Falha ao atualizar pessoa física", { autoClose: 3000 });
    throw error;
  }
})

export const deleteIndividual = createAsyncThunk("crm/deleteIndividual" , async (individualId:string) => {
  try{
    await individualsService.delete(individualId);
    toast.success("Pessoa física excluída com sucesso", { autoClose: 3000 });
    return individualId;
  }catch (error: any) {
    toast.error(error.response?.data?.message || "Falha ao excluir pessoa física", { autoClose: 3000 });
    throw error;
  }
})

export const addNewContact = createAsyncThunk("crm/addNewContact" , async (contact:any) => {
  try{
    const response = addNewContactApi(contact)
    toast.success("Contact Added Successfully", { autoClose: 3000 });
    return response;
  }catch (error) {
    toast.error("Contact Added Failed", { autoClose: 3000 });
    return error;
  }
})

export const updateContact = createAsyncThunk("crm/updateContact" , async (contact:any) => {
  try{
    const response = updateContactApi(contact)
    toast.success("Contact Updated Successfully", { autoClose: 3000 });
    return response;
  }catch (error) {
    toast.error("Contact Updated Failed", { autoClose: 3000 });
    return error;
  }
})

export const deleteContact = createAsyncThunk("crm/deleteContact" , async (contact:any) => {
  try{
    const response = deleteContactApi(contact)
    toast.success("Contact Deleted Successfully", { autoClose: 3000 });
    return { contact, ...response };
  }catch (error) {
    toast.error("Contact Deleted Failed", { autoClose: 3000 });
    return error;
  }
})

export const getLeads = createAsyncThunk("crm/getLeads" , async () => {
  try{
    const response = getLeadsApi()
    return response;
  }catch (error) {
    return error;
  }
})

export const addNewLead = createAsyncThunk("crm/addNewLead" , async (lead:any) => {
  try{
    const response = addNewLeadApi(lead)
    toast.success("Lead Added Successfully", { autoClose: 3000 });
    return response;
  }catch (error) {
    toast.error("Lead Added Failed", { autoClose: 3000 });
    return error;
  }
})

export const updateLead = createAsyncThunk("crm/updateLead" , async (lead:any) => {
  try{
    const response = updateLeadApi(lead)
    toast.success("Lead Updated Successfully", { autoClose: 3000 });
    return response;
  }catch (error) {
    toast.error("Lead Updated Failed", { autoClose: 3000 });
    return error;
  }
})

export const deleteLead = createAsyncThunk("crm/deleteLead" , async (leads:any) => {
  try{
    const response = deleteLeadApi(leads)
    toast.success("Lead Deleted Successfully", { autoClose: 3000 });
    return { leads, ...response };

  }catch (error) {
    toast.error("Lead Deleted Failed", { autoClose: 3000 });
    return error;
  }
})

export const getDeals = createAsyncThunk("crm/getDeals" , async () => {
  try{
    const response = getDealsApi()
    return response;
  }catch (error) {
    return error;
  }
})